import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { CountriesService } from '../services/countries.service';
import { BehaviorSubject, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatOption } from '@angular/material/autocomplete';
import { AsyncPipe } from '@angular/common';
import { CountryNamePipe } from '../pipes/country-name.pipe';

@Component({
    selector: 'app-country-field',
    imports: [
        MatFormField,
        MatInput,
        MatLabel,
        MatSuffix,
        ReactiveFormsModule,
        MatAutocomplete,
        MatOption,
        MatAutocompleteTrigger,
        AsyncPipe,
        CountryNamePipe,
        MatSuffix,
        MatError
    ],
    templateUrl: './country-field.component.html',
    styleUrl: './country-field.component.scss'
})
export class CountryFieldComponent implements OnInit, OnDestroy {

    @Input()
    public control: FormControl;

    @Output()
    public change: EventEmitter<void> = new EventEmitter<void>();

    @ViewChild('formInput', { read: MatInput })
    public formInput: MatInput;

    private formValueSubscriber: Subscription;

    constructor(private countries: CountriesService) {
    }

    public inputChanges = new BehaviorSubject<string>('');
    public filteredCountries$ = this.inputChanges.pipe(
        map(input => this.countries.countryFilter(input))
    );

    ngOnInit(): void {
        this.formValueSubscriber = this.control.valueChanges.pipe(
            startWith(this.control.value)
        ).subscribe(value => this.inputChanges.next(value));
    }

    ngOnDestroy(): void {
        this.formValueSubscriber.unsubscribe();
    }

    normalizeInput(): void {
        let countryCode = this.formInput.value.toUpperCase();
        if (countryCode === '' && this.formInput.value === '') {
            return;
        }
        if (!this.countries.isCountryCode(countryCode)) {
            const list = this.countries.countryFilter(countryCode);
            if (list.length > 0) {
                countryCode = list[0];
            } else {
                countryCode = this.formInput.value;
            }
        }
        if (countryCode !== this.formInput.value) {
            this.formInput.value = countryCode;
            this.control.setValue(countryCode);
            this.inputChanges.next(countryCode);
        }

    }

    onBlur(): void {
        /* delay effect to give (optionSelected) time to fire */
        setTimeout(() => {
            this.normalizeInput();
        });
    }

    onInput(): void {
        this.inputChanges.next(this.formInput.value);
    }

    onOptionSelected($event: MatAutocompleteSelectedEvent): void {
        this.formInput.value = $event.option.value;
        this.control.setValue($event.option.value);
        this.inputChanges.next($event.option.value);
        this.change.emit();
    }

}
